// @ts-expect-error untyped loader
import * as currentPackage from 'current-package-loader!';
import { AppInfo, ChirpGateway, FetchMiddleware } from '../types';
import { chirpGateways } from '../constants';

export function getCoreServiceContext() {
  return {
    location: window.location,
    cookie: window.document.cookie,
    currentPackage: currentPackage as AppInfo,
  };
}

export const includeCredentials: FetchMiddleware<{ gateway: ChirpGateway }> = (
  params,
  context
) => {
  // For external APIs, don't include credentials
  // This prevents cookies from being sent to third-party services
  const credentials =
    context.gateway === chirpGateways.EXTERNAL ? 'omit' : 'include';

  return {
    ...params,
    init: {
      ...params.init,
      credentials,
    },
  };
};
